<app-paciente-navbar></app-paciente-navbar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-atom" [fullScreen]="true">
    <p style="color: white"> Carregando... </p>
</ngx-spinner>
<router-outlet></router-outlet>